<div class="form-container"  *ngIf="!cargaDatos1 && !cargaDatos2">
  <div id="titulo">
    <h2>Petición {{peticion}}</h2>
    <span style="flex: 1 1 auto;"></span>
  </div>
  <mat-card class="descriptor-container" style="width: 100%">
    <mat-card-content>
      <div class="descriptor-pair" style="width: 100%">
        <span class="descriptor">Tipo: </span>
        <span class="non-editable-field">{{ tipo }}</span>
      </div>
    </mat-card-content>
  </mat-card>
  <div class="grid-container" style="margin-top: -10px !important;">
    <mat-card class="descriptor-container">
      <mat-card-content>
        <div class="descriptor-pair">
          <span class="descriptor">Estado: </span>
          <span class="non-editable-field">{{ estado }}</span>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="descriptor-container">
      <mat-card-content>
        <div class="descriptor-pair">
          <span class="descriptor">Gestión: </span>
          <span class="non-editable-field">{{ gestion_pet }}</span>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="descriptor-container">
      <mat-card-content>
        <div class="descriptor-pair">
          <span class="descriptor">Matrícula: </span>
          <span class="non-editable-field">{{ matricula }}</span>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="descriptor-container">
      <mat-card-content>
        <div class="descriptor-pair">
          <span class="descriptor">Coste: </span>
          <span class="non-editable-field">{{ coste }}</span>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <h3 class="descriptor" style="margin: 1px;  padding-left: 10px;">Peticiones complementarias</h3>
  <div class="grid-container" *ngFor="let peticion of peticionesComplementarias">
    <mat-card class="descriptor-container">
      <mat-card-content>
        <div class="descriptor-pair">
          <span class="descriptor">ID: </span>
          <span class="non-editable-field">{{ peticion[0] }}</span>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="descriptor-container">
      <mat-card-content>
        <div class="descriptor-pair">
          <span class="descriptor">Estado: </span>
          <span class="non-editable-field">{{ this.traduccionEstado[peticion[1].toString().trim()] }}</span>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div *ngIf="peticionesComplementarias.length == 0" class="no-data-message">
    No hay peticiones complementarias.
  </div>
  <h3 class="descriptor" style="margin: 1px;   padding-left: 10px;" *ngIf="comentarios.length>0">Comentarios</h3>
  <div class="tablaContainer" *ngIf="comentarios.length>0" >
    <table mat-table [dataSource]="comentarios" class="tabla-mess notHover" >
      <ng-container matColumnDef="mensaje">
        <td mat-cell *matCellDef="let message"> {{ message}} </td>
      </ng-container>

      <tr mat-row *matRowDef="let row; columns: displayedColumnsComentarios;"></tr>
    </table>
  </div>
  <h3 class="descriptor" style="margin: 1px;   padding-left: 10px;" *ngIf="gestion > 0 || messages.length>0">Mensajes</h3>
  <div class="tablaContainer" *ngIf="messages.length>0" >
    <table mat-table [dataSource]="messages" class="tabla-mess" >
      <ng-container matColumnDef="mensaje">
        <th mat-header-cell *matHeaderCellDef> Mensaje </th>
        <td mat-cell *matCellDef="let message"> {{ message[0] }} </td>
      </ng-container>
      <ng-container matColumnDef="usuario">
        <th mat-header-cell *matHeaderCellDef> Usuario </th>
        <td mat-cell *matCellDef="let message"> {{ message[1] }} </td>
      </ng-container>
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef> Fecha/Hora </th>
        <td mat-cell *matCellDef="let message"> {{ message[2] }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsMensajes"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsMensajes;"></tr>
    </table>
  </div>
  <mat-form-field appearance="outline" class="full-width" *ngIf="gestion > 0">
    <textarea matInput style="height: 3em; resize: none; color: #294634" [(ngModel)]="this.comentarioInsertar" placeholder="Añadir mensaje:"></textarea>
  </mat-form-field>
  <mat-dialog-actions align="center" *ngIf="gestion > 0">
    <a class="btnPrin btnStyle" mat-flat-button (click)="insertarComentario()" >Añadir Comentario</a>
  </mat-dialog-actions>

</div>

<div class="container-spiner" *ngIf="cargaDatos1 || cargaDatos2">
  <mat-spinner></mat-spinner>
</div>
